export function IconAttachment() {
    return <svg
        xmlns="http://www.w3.org/2000/svg"
        width={25}
        height={24}
        fill="none"
    >
        <path
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="m16.5 6-8.414 8.586a2 2 0 1 0 2.829 2.83l8.414-8.587a4 4 0 1 0-5.657-5.657l-8.379 8.551a6 6 0 1 0 8.485 8.485l8.379-8.55"
        />
    </svg>;
}
